import type { JSX } from 'react';
import { DateTime } from '@ksyos/date-time';
import type { BariatricsExternalReferralData } from '@common/validation/customControls/bariatrics/bariatricsExternalReferral/v1/bariatricsExternalReferralSchema';
import { orderedPractitionerTypes, TypeBehandelaar } from '@common/customControls/bariatrics';
import { ProcessActivityAssetsDropzone } from '@frontend/components/pages/episodeCategory/customControls/processActivityAssets/ProcessActivityAssetsDropzone';
import { useProcessActivityEditContext } from '@frontend/utils';
import {
    DateInputFormGroup,
    SelectFormGroup,
    TextAreaFormGroup,
    TextInputFormGroup,
} from '../processActivityFormGroupFields';
import { BariatricsExternalReferralAlert } from './BariatricsExternalReferralAlert';

export function BariatricsExternalReferral(): JSX.Element {
    const { data, onChange } = useProcessActivityEditContext<BariatricsExternalReferralData>();

    return (
        <>
            <ProcessActivityAssetsDropzone
                errorText="Voeg alsjeblieft het bestand met de verwijsbrief toe"
                isRequired={true}
                label="Verwijsbrief"
            />
            <DateInputFormGroup
                fieldKey="datum_verwijzing"
                isRequired={true}
                label="Datum verwijzing"
                maxDate={DateTime.now().format()}
            />
            <SelectFormGroup
                fieldKey="type_behandelaar"
                isRequired={true}
                label="Type behandelaar"
                onChange={(value) =>
                    onChange(
                        {
                            type_behandelaar: value as TypeBehandelaar | null,
                            type_behandelaar_overig: null,
                        },
                        'type_behandelaar'
                    )
                }
                options={orderedPractitionerTypes.map((practitionerType) => ({
                    label: practitionerType,
                    value: practitionerType,
                }))}
                placeholder="Selecteer type behandelaar"
            />
            {data.type_behandelaar === TypeBehandelaar.overig && (
                <TextInputFormGroup
                    fieldKey="type_behandelaar_overig"
                    isRequired={true}
                    label="Type behandelaar overig"
                />
            )}
            <TextInputFormGroup
                fieldKey="naam_externe_behandelaar"
                isRequired={true}
                label="Naam externe behandelaar"
            />
            <TextAreaFormGroup
                fieldKey="reden_doorverwijzing"
                isRequired={true}
                label="Reden doorverwijzing"
            />
            <BariatricsExternalReferralAlert />
        </>
    );
}
